export const tr = {
  brand: { name: "SDIP AI", core: "ATLAS", tagline: "Premium Spor Zekâsı" },
  nav: {
    product: "Ürün", live: "Canlı", prematch: "Maç Öncesi", atlas: "ATLAS Asistan",
    performance: "Performans", pricing: "Üyelik", faq: "SSS", login: "Giriş Yap", register: "Kayıt Ol",
    dashboard: "Genel Bakış", matchDetail: "Maç Analizi", history: "Sinyal Geçmişi",
    notifications: "Bildirimler", membership: "Üyelik", account: "Hesap", settings: "Ayarlar",
    analysis: "Analiz Listem",
    coupons: "Kupon Merkezi", support: "Yardım & Destek", admin: "Admin Merkezi",
  },
  common: {
    loading: "Yükleniyor…", retry: "Tekrar dene", refresh: "Yenile", viewAll: "Tümünü gör",
    search: "Ara", filter: "Filtrele", all: "Tümü", live: "Canlı", min: "dk", odds: "Oran",
    refOdds: "Referans oran", confidence: "Güven", risk: "Risk", market: "Market", explanation: "Açıklama",
    score: "Skor", finalScore: "Final skor", momentum: "Momentum", pressure: "Baskı",
    shots: "Şut", shotsOn: "İsabetli", corners: "Korner", kickoff: "Başlama", signalId: "Sinyal No",
    resolved: "Sonuçlandı", none: "—", upgrade: "Yükselt", locked: "Kilitli", back: "Geri",
    learnMore: "Detaylar", getStarted: "Hemen başla", openApp: "Uygulamaya git", generatedAt: "Güncelleme",
    priceSoon: "Fiyat yakında", riskUnavailable: "Risk verisi mevcut değil",
  },
  states: {
    emptyLiveTitle: "Şu anda aktif sinyal yok.",
    emptyLiveHint: "ATLAS canlı maçları izlemeye devam ediyor.",
    emptyPrematch: "ATLAS'ın şu anda değerlendirdiği yaklaşan maç bulunamadı.",
    emptyHistory: "Kayıt bulunamadı.",
    emptyNotifications: "Yeni bildirim yok.",
    unavailable: "Bu veri şu anda mevcut değil.",
    noConnection: "SDIP servisine bağlanılamadı.",
    reconnecting: "Bağlanıyor…",
    unauthorized: "Devam etmek için giriş yap.",
    insufficient: "Bu görünüm için henüz yeterli veri yok.",
  },
  atlas: {
    title: "ATLAS Asistan", subtitle: "Maçları ve ATLAS analizlerini konuşarak incele",
    placeholder: "ATLAS'a bir maç ya da market sor…",
    connectTitle: "Devam etmek için giriş yap",
    connectBody: "ATLAS Asistan'ı kullanmak için hesabınla giriş yapman gerekiyor. Giriş yaptığında maçları ve analizleri konuşarak inceleyebilirsin.",
    connectCta: "Giriş Yap",
    suggestions: ["Bugün ne buldun?", "Canlıda ne izliyorsun?", "En güçlü prematch seçimin hangisi?", "Alternatif seçenekler neler?", "Korner tarafında ne izliyorsun?"],
  },
  result: { pending: "Bekliyor", win: "Kazandı", lose: "Kaybetti", live: "Canlı" },
  live: {
    signalsTab: "ATLAS Sinyalleri", matchesTab: "Canlı Maçlar", resolvedTab: "Sonuçlanan",
    monitoringTitle: "ATLAS canlı izleme",
    monitoringBody: "Şu anda aktif bir canlı sinyal yok. ATLAS maçları izlemeye devam ediyor; yeterli baskı oluştuğunda sinyal üretilecek.",
    fixturesUnavailable: "Şu anda ATLAS'ın izlediği maçlar gösteriliyor.",
    fixturesUnavailableHint: "Şu anda ATLAS'ın izlediği maçlar gösteriliyor. Yeni maçlar değerlendirmeye alındıkça burada görünür.",
    monitored: "İzlenen maç", pending: "Aktif sinyal", resolvedToday: "Bugün sonuçlanan",
  },
  explorer: {
    exploreTab: "Maç Kâşifi", picksTab: "ATLAS Seçimleri", resolvedTab: "Sonuçlanan",
    today: "Bugün", tomorrow: "Yarın", next24: "24 Saat", all: "Tümü",
    withAtlas: "ATLAS seçimli", riskLevel: "Risk", market: "Market",
    noAtlas: "Bu maç için ATLAS seçimi yok",
    emptyExplorer: "ATLAS'ın şu anda değerlendirdiği yaklaşan maç bulunamadı.",
  },
  analysis: {
    title: "Analiz Listem",
    subtitle: "Seçimleri bir araya getir, ATLAS penceresinden birlikte incele. Bu bir bahis aracı değildir.",
    empty: "Analiz listen boş.",
    emptyHint: "Canlı veya maç öncesi seçimleri listene ekleyerek birlikte inceleyebilirsin.",
    analyze: "Kuponu Analiz Et", clear: "Listeyi temizle", remove: "Çıkar",
    overallRisk: "Genel risk profili", strongest: "En güçlü seçim", weakest: "En zayıf seçim",
    highVariance: "Dalgalı seçimler", marketConc: "Market yoğunlaşması", leagueConc: "Lig yoğunlaşması",
    timingConflict: "Zaman çakışması", reviewCandidates: "Gözden geçirilebilir",
    selections: "seçim", notWager: "Analiz aracı · bahis değil",
    deepTitle: "ATLAS derinlemesine değerlendirme",
  },
  notifPrefs: {
    title: "Bildirim tercihleri",
    browser: "Tarayıcı bildirimleri",
    enabled: "Etkin", permissionRequired: "İzin gerekli", denied: "Reddedildi", unsupported: "Desteklenmiyor",
    enable: "Bildirimleri etkinleştir",
    followedTitle: "Takip edilen maçlar", noFollowed: "Henüz maç takip etmiyorsun.",
    events: "Hangi olaylarda haber verelim?",
  },
};

export type Dict = typeof tr;
